import React from 'react';
import PropTypes from 'prop-types';


import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { MetaResourceRendererLite } from './MetaResourceRendererLite';

const defaultMetaOverrideSet = buildFacetDesignOverride();

export const MetaResourceRenderer = ({
  metaOverrideSet,
  resource,
  layout,
  LayoutProps,
  onSubmit,
  onDelete,
  onChange,
  confirmDeleteMessage,
  fieldsImmediatelyRequired,
  errors,
}) => (<MetaResourceRendererLite
  metaOverrideSet={metaOverrideSet}
  resource={resource}
  layout={layout}
  LayoutProps={LayoutProps}
  onSubmit={onSubmit}
  onDelete={onDelete}
  onChange={onChange}
  confirmDeleteMessage={confirmDeleteMessage}
  fieldsImmediatelyRequired={fieldsImmediatelyRequired}
  errors={errors}
/>);

MetaResourceRenderer.defaultProps = {
  metaOverrideSet: defaultMetaOverrideSet,
  onSubmit: () => {},
  onDelete: () => {},
  onChange: () => {},
  confirmDeleteMessage: undefined,
  LayoutProps: {},
  fieldsImmediatelyRequired: false,
  errors: null,
};

MetaResourceRenderer.propTypes = {
  metaOverrideSet: PropTypes.object,
  resource: PropTypes.object.isRequired,
  layout: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
  onChange: PropTypes.func,
  confirmDeleteMessage: PropTypes.string,
  LayoutProps: PropTypes.object,
  fieldsImmediatelyRequired: PropTypes.bool,
  errors: PropTypes.array,
};
